// AI GENERATED
import Skeleton from "react-loading-skeleton";
import cls from "./styles.module.css";

export default function Loading() {
  const lineHeight = 16; // Standard line height for small text
  const metadataHeight = 20; // Height for the metadata line

  return (
    // Wrap this in your header container with appropriate width
    <div className={cls.root}>
      {/* 1. Category/Tag Skeleton ("Природа") */}
      <div style={{ textAlign: "center", marginBottom: "8px" }}>
        <Skeleton height={lineHeight} width="80px" />
      </div>

      {/* 2. Main Title Skeleton ("Щеглы на окраинах города") */}
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
        {/* The title is large and centered */}
        <Skeleton height={40} width="60%" style={{ margin: "0 auto" }} />
      </div>

      {/* 3. Metadata Skeleton (Date, Likes, Views) */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        {/* Date (e.g., 11 сентября 2025 г.) */}
        <Skeleton
          height={metadataHeight}
          width="150px"
          style={{ display: "inline-block", marginRight: "15px" }}
        />
        {/* Likes and Views (small icons/numbers) */}
        <Skeleton
          height={metadataHeight}
          width="50px"
          style={{ display: "inline-block" }}
        />
      </div>

      {/* 4. Image Skeleton (The large featured image) */}
      {/* The image is the main element, using 16:9 aspect ratio or similar for proportional size */}
      <div style={{ aspectRatio: "16 / 9", marginBottom: "10px" }}>
        <Skeleton height="100%" />
      </div>
    </div>
  );
}
